import React from 'react';

const NoteTag = ({ color = '#757575', width = 20, height = 20, ...rest }, ref) => {
  return (
    <svg
      {...rest}
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}>
      <path
        d="M14.6875 17.4972C15.2222 17.022 16.0278 17.022 16.5625 17.4972C16.9258 17.8201 17.5 17.5622 17.5 17.0762V2.91806C17.5 2.43204 16.9258 2.17417 16.5625 2.49706C16.0278 2.97231 15.2222 2.97231 14.6875 2.49706C14.1528 2.02181 13.3472 2.02181 12.8125 2.49706C12.2778 2.97231 11.4722 2.97231 10.9375 2.49706C10.4028 2.02181 9.59716 2.02181 9.0625 2.49706C8.52784 2.97231 7.72216 2.97231 7.1875 2.49706C6.65284 2.02181 5.84716 2.02181 5.3125 2.49706C4.77784 2.97231 3.97216 2.97231 3.4375 2.49706C3.07424 2.17417 2.5 2.43204 2.5 2.91806V17.0762C2.5 17.5622 3.07424 17.8201 3.4375 17.4972C3.97216 17.022 4.77784 17.022 5.3125 17.4972C5.84716 17.9725 6.65284 17.9725 7.1875 17.4972C7.72216 17.022 8.52784 17.022 9.0625 17.4972C9.59716 17.9725 10.4028 17.9725 10.9375 17.4972C11.4722 17.022 12.2778 17.022 12.8125 17.4972C13.3472 17.9725 14.1528 17.9725 14.6875 17.4972Z"
        stroke={color}
        strokeWidth="1.25"
      />
      <path d="M6.25 12.918H13.75" stroke={color} strokeWidth="1.25" strokeLinecap="round" />
      <path d="M6.25 10H13.75" stroke={color} strokeWidth="1.25" strokeLinecap="round" />
      <path d="M6.25 7.08203H13.75" stroke={color} strokeWidth="1.25" strokeLinecap="round" />
    </svg>
  );
};

export default React.forwardRef(NoteTag);
